import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { ClientOutputDTO, ApplicationByClientOutputDTO } from './clientDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class ClientServices {
  async getById(id: number): Promise<ClientOutputDTO> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/client/${id}`,
      {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
  async getByAll(): Promise<ClientOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/client`,
      {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }

  async getApplicationByClient(id: number): Promise<ApplicationByClientOutputDTO[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_AUTH}/applicationByClient/client/${id}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
}

export const clientServices = new ClientServices()
